import dayjs from 'dayjs';

import { getAuthenticatedToken } from '../../../services/authToken';
import { EnvironmentVariable } from '../../../utils/constants';

import { UserEngagementData } from './organization.types';

export const getPreEmploymentData = async (organization: string, limit: number) => {
  const preEmploymentUrl = process.env.REACT_APP_ORGANIZATION_PRE_EMPLOYMENT_URL!;

  const token = await getAuthenticatedToken();

  const response = await fetch(`${preEmploymentUrl}?organization=${organization}&limit=${limit}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();
  return result.usersData;
};

export const getUserEngagementData = async (organization: string, limit: number) => {
  const getUserEngagementurl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_USER_ENGAGEMENT_URL];
  const token = await getAuthenticatedToken();

  const response = await fetch(
    `${getUserEngagementurl}?organization=${organization}&limit=${limit}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const result = await response.json();
  return result.usersData; // {size:number,employeeData:[]}
};

export const getUserCourseData = async (organization: string, limit: number) => {
  const getUserCourseUrl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_USER_COURSE_DATA_URL];
  const token = await getAuthenticatedToken();

  const response = await fetch(`${getUserCourseUrl}?organization=${organization}&limit=${limit}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  return result.usersData; // {size:number,employeeData:[]}
};

export const getOrganizationUserStastics = async (organization: string, limit: number) => {
  const getOrganizationUserStasticsUrl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_ALL_USER_STASTIC_URL];
  const token = await getAuthenticatedToken();

  const response = await fetch(
    `${getOrganizationUserStasticsUrl}?organization=${organization}&limit=${limit}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const result = await response.json();
  return result?.usersData; // {totalUsersCount:number,completedPreEmploymentCount:number,pending:number}
};

export const dispatchReminderEmail = async (user: UserEngagementData) => {
  const reminderUrl = process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_REMINDER_EMAIL_URL];
  const token = await getAuthenticatedToken();
  if (reminderUrl) {
    const response = await fetch(reminderUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ to: user?.email, userName: user?.name || user?.email }),
    });
    return response;
  }
  return;
};

// Report APi----------------------------------------------------------------------------------->

const formatDate = (date: dayjs.Dayjs) => date.format('YYYY-MM-DD');
const nodeEnvironment = process.env[EnvironmentVariable.REACT_APP_NODE_ENV]; // stage or Prod

export const getOrganizaationAllUserSwotReport = async (
  organization: string,
  startDate?: string,
  endDate?: string,
) => {
  const defaultFromDate = dayjs('2023-10-01T12:31:10+05:30');
  const defaultToDate = dayjs().add(1, 'day'); // Add 1 day to today

  if (!startDate) {
    startDate = formatDate(defaultFromDate);
  } else {
    startDate = formatDate(dayjs(startDate).subtract(1, 'day'));
  }

  if (!endDate) {
    endDate = formatDate(defaultToDate);
  } else {
    endDate = formatDate(dayjs(endDate).add(1, 'day'));
  }
  const organizaationAllUserSwotReportUrl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_USER_SWOT_REPORT_URL];
  const token = await getAuthenticatedToken();

  const response =
    organizaationAllUserSwotReportUrl &&
    (await fetch(organizaationAllUserSwotReportUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        organization: organization,
        startDate: startDate,
        endDate: endDate,
        env: nodeEnvironment,
      }),
    }));
  const result = response && (await response.json());
  return result.result; // {swotData:{},totalUsers:number}
};

export const getSwotReportAsPerRegionAndAge = async (
  organization: string,
  startDate?: string,
  endDate?: string,
) => {
  const defaultFromDate = dayjs('2023-10-01T12:31:10+05:30');
  const defaultToDate = dayjs().add(1, 'day'); // Add 1 day to today

  if (!startDate) {
    startDate = formatDate(defaultFromDate);
  } else {
    startDate = formatDate(dayjs(startDate).subtract(1, 'day'));
  }

  if (!endDate) {
    endDate = formatDate(defaultToDate);
  } else {
    endDate = formatDate(dayjs(endDate).add(1, 'day'));
  }
  const SwotReportAsPerRegionAndAgeUrl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_USER_SWOT_REPORT_REGION_AGE_URL];
  const token = await getAuthenticatedToken();

  const response =
    SwotReportAsPerRegionAndAgeUrl &&
    (await fetch(SwotReportAsPerRegionAndAgeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        organization: organization,
        startDate: startDate,
        endDate: endDate,
        env: nodeEnvironment,
      }),
    }));
  // return response;
  const result = response && (await response.json());
  return result.result; // {swotData:{},totalUsers:number}
};

export const getPreAssessmentReportByRegion = async (
  organization: string,
  startDate?: string,
  endDate?: string,
) => {
  const defaultFromDate = dayjs('2023-10-01T12:31:10+05:30').subtract(1, 'day');
  const defaultToDate = dayjs().add(1, 'day'); // Add 1 day to today

  if (!startDate) {
    startDate = formatDate(defaultFromDate);
  } else {
    startDate = formatDate(dayjs(startDate).subtract(1, 'day'));
  }

  if (!endDate) {
    endDate = formatDate(defaultToDate);
  } else {
    endDate = formatDate(dayjs(endDate).add(1, 'day'));
  }
  const PreAssessmentReportByRegionUrl =
    process.env[EnvironmentVariable.REACT_APP_ORGANIZATION_USER_PREASSESSMENT_REPORT_REGION_URL];
  const token = await getAuthenticatedToken();

  const response =
    PreAssessmentReportByRegionUrl &&
    (await fetch(PreAssessmentReportByRegionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        organization: organization,
        startDate: startDate,
        endDate: endDate,
        env: nodeEnvironment,
      }),
    }));
  const result = response && (await response.json());
  return result.result; // {swotData:{},totalUsers:number}
};
